<template>
  <div class="app-container">
    <div v-if="showPassword">
      <!-- 旧密码的输入框 -->
      <PasswordCard
        v-if="!isSetPassword"
        v-model="oldPassWord"
        :title="$t('pleaseEnterPassword')"
        @submit="handleSubmitPassword"
      >
        <template #otp>
          <div class="forgot" @click="$router.push({name: 'OTP'})">{{ $t('forgot_your_password') }}</div>
        </template>
      </PasswordCard>

      <!-- 新密码的输入框 -->
      <DoubleCheckPasswordCard
        v-if="isSetPassword"
        v-model="newPassWord"
        :old-password="oldPassWord"
        @submit="handleSubmitNewPassword"
      />
    </div>

    <PayLoading
      :context="$t('passWordWaitText')"
      :is-show="loading"
    />
  </div>
</template>

<script>
import { updatePayPassword, verifyPayPassword } from '@/api/me'
import { setTransactionPassMd5 } from '@/utils/safe'
import PayLoading from '@/components/PayLoading'
import PasswordCard from '@/components/PasswordCard/index.vue'
import DoubleCheckPasswordCard from '@/components/DoubleCheckPasswordCard/index.vue'
export default {
  name: 'MeChangePayPassword',

  components: {
    PayLoading,
    PasswordCard,
    DoubleCheckPasswordCard
  },

  data () {
    return {
      showPassword: true,
      isSetPassword: false,
      oldPassWord: '',
      newPassWord: '',
      loading: false
    }
  },

  methods: {
    handleSubmitPassword () {
      this.loading = true
      verifyPayPassword({ password: setTransactionPassMd5(this.oldPassWord) })
        .then((data) => {
          this.isSetPassword = true
        })
        .catch(() => {
          this.oldPassWord = ''
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSubmitNewPassword () {
      this.loading = true
      updatePayPassword({
        oldPassword: setTransactionPassMd5(this.oldPassWord),
        password: setTransactionPassMd5(this.newPassWord)
      })
        .then((data) => {
          this.showPassword = false
          this.$router.replace({ name: 'Me' })
        })
        .finally(() => {
          this.loading = false
          this.newPassWord = ''
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.forgot {
  color: #28aa91;
  position: absolute;
  right: 0;
  margin-top: 20px;
}
</style>
